import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useState } from 'react';
import { getLocationById, getLocationStorageKey, getPrimaryLocation } from './use-locations.utils';
import useStorageHook from '../../../../hooks/use-storage';
var defaultOptions = {
  initialActiveLocation: {},
  defaultToPrimary: false,
  useStorage: false,
  siteId: null
};
export default function useLocations(locations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var finalOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  var defaultToPrimary = finalOptions.defaultToPrimary,
    useStorage = finalOptions.useStorage,
    siteId = finalOptions.siteId;
  var initialActiveLocation = finalOptions.initialActiveLocation;
  var primaryLocation = getPrimaryLocation(locations);
  if (defaultToPrimary) {
    initialActiveLocation = primaryLocation;
  }
  if (useStorage) {
    initialActiveLocation = primaryLocation; // used as default value
  }

  var _useStorageHook = useStorageHook(getLocationStorageKey(siteId), initialActiveLocation),
    _useStorageHook2 = _slicedToArray(_useStorageHook, 3),
    activeLocationStorage = _useStorageHook2[0],
    setActiveLocationStorage = _useStorageHook2[1],
    storageLoaded = _useStorageHook2[2];
  var _useState = useState(initialActiveLocation),
    _useState2 = _slicedToArray(_useState, 2),
    activeLocation = _useState2[0],
    setActiveLocation = _useState2[1];
  return {
    locations: locations,
    activeLocation: useStorage ? getLocationById(locations, activeLocationStorage === null || activeLocationStorage === void 0 ? void 0 : activeLocationStorage.id) || primaryLocation : activeLocation,
    setActiveLocation: useStorage ? setActiveLocationStorage : setActiveLocation,
    loaded: useStorage ? storageLoaded : true
  };
}